export let Status = /*#__PURE__*/function (Status) {
  Status["Synced"] = "synced";
  Status["SyncFailed"] = "syncFailed";
  Status["PendingSync"] = "pendingSync";
  Status["SyncInProgress"] = "syncInProgress";
  return Status;
}({});